module.exports = __webpack_public_path__ + "img/vitech-logo-complete.449cf2dd.png";